import React, { FC, useState } from 'react';
import { SCUIButton, SCUINoRecordComponent } from '../../../atomic/atoms';
import { SCUIContent } from '../../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIBillingGoalDrawerContent, SCUIBillingGoalAddToListModal } from './components';
import {
    SCUIGeneralDrawer,
    SCUICustomDataGrid,
    SCUITextFieldWithButton,
    SCUIBreadCrumb,
} from '../../../atomic/molecules';
import { BillingCommand } from '../../../services/command';
import { Box, Grid, Chip } from '@mui/material';
import Helper from '../../../utils/helper';

export const BillingGoal: FC<any> = () => {
    const { t } = useTranslation();
    const backofficeUrl = Helper.getBackofficeUrl();

    const [listModalOpen, setListModalOpen] = useState(false);
    const [billingServiceID, setBillingServiceID] = useState<any>();
    const [orderNo, setOrderNo] = useState('');
    const [datas, setDatas] = React.useState<any>();
    const onDrawerOpen = () => setDrawerOpen(true);
    const onDrawerClose = () => setDrawerOpen(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const handleCloseModal = () => {
        setListModalOpen(false);
    };
    const handleShowBill = (item: any) => {
        setBillingServiceID(item.shippmentId);
        onDrawerOpen();
    };
    const [visibleResendButton, setVisibleResendButton] = useState(false);

    const failedInvoiceList = () => {
        let params: any = {};
        params.getBillingInformationType = 7;
        params.referenceId = 0;

        BillingCommand.PostGetBillingInformation(params).then((res: any) => {
            if (res.data) {
                setDatas(
                    JSON.parse(res.data).map(function (value: any, idx: any) {
                        return {
                            id: idx,
                            shippmentId: value,
                            failed: true,
                        };
                    })
                );
                setVisibleResendButton(true);
            } else {
                setDatas([]);
                setVisibleResendButton(false);
            }
        });
    };

    const listele = async () => {
        if (orderNo.trim().length === 0) {
            Swal.fire({
                icon: 'error',
                title: t('general.emptyFieldControlText'),
                showConfirmButton: false,
                timer: 1500,
            });
        } else {
            let tempArr: any = [];
            orderNo
                .trim()
                .split('\n')
                .forEach((item: any, idx: number) => {
                    let my_json = { id: idx, shippmentId: item, failed: false };
                    if (item.trim().length > 0) {
                        tempArr.push(my_json);
                    }
                });
            setDatas(tempArr);
            setVisibleResendButton(false);

            handleCloseModal();
        }
    };

    const reSend = async (shipmentId?: number) => {
        Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('general.complete'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                if (shipmentId) params.shippingListId = Number(shipmentId);
                params.documentType = 0;
                params.updateBillingInformationType = shipmentId ? 3 : 2;
                BillingCommand.UpdateBillingInformation(params).then((res: any) => {
                    if (res && res.isSucceeded) {
                        Swal.fire(t('general.recordUpdated') + res.result, ' ', 'success');
                        if (!shipmentId) {
                            failedInvoiceList();
                        }
                    } else {
                        Swal.fire(res.errorMessage, ' ', 'error');
                    }
                });
            }
        });
    };
    return (
        <SCUIContent>
            <SCUIBillingGoalAddToListModal
                open={listModalOpen}
                onClose={handleCloseModal}
                orderNo={orderNo}
                setOrderNo={setOrderNo}
                listele={listele}
            />
            <SCUIGeneralDrawer
                open={drawerOpen}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerOpen(false);
                    }
                }}
            >
                <SCUIBillingGoalDrawerContent id={billingServiceID} onClose={onDrawerClose} />
            </SCUIGeneralDrawer>
            <Box className="billing-goal">
                <Grid
                    className="billing-goal-header"
                    container
                    direction="row"
                    spacing={2}
                    sx={{ marginLeft: '0.5rem', marginBottom: '16px' }}
                >
                    <SCUIBreadCrumb title={t('billingServiceLog.goalServiceLog')} componentLink={'billingGoal'} />
                    <Grid
                        className="billing-goal-shipping-id-search"
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 4,
                            xl: 4,
                        }}
                    >
                        <SCUITextFieldWithButton
                            placeholder={t('general.shippingID')}
                            onChange={(event: any) => {
                                setOrderNo(event.target.value);
                            }}
                            onClick={() => listele()}
                            onKeyPress={(e: any) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    listele();
                                }
                            }}
                        />
                    </Grid>
                    <Grid
                        className="billing-goal-header-actions"
                        sx={{ marginLeft: '16px', display: 'flex', flexDirection: 'row', gap: '16px' }}
                        size={{
                            md: 4,
                            lg: 4,
                            xl: 4,
                        }}
                    >
                        <SCUIButton
                            className="billing-goal-batch-search-button"
                            text={t('general.batchSearch')}
                            type="secondary"
                            sizeType="fixed"
                            size={'m'}
                            onClick={() => setListModalOpen(true)}
                        />
                        <SCUIButton
                            className="billing-goal-get-failed-invoice-button"
                            text={t('billingServiceLog.getFailedInvoice')}
                            type="primary"
                            style={{ marginLeft: '16px' }}
                            sizeType="fixed"
                            size={'m'}
                            onClick={failedInvoiceList}
                        />
                    </Grid>
                </Grid>
                {datas ? (
                    <Grid className="billing-goal-results" container direction="row" sx={{ marginLeft: '0.5rem' }}>
                        <Grid
                            className="billing-goal-results-title"
                            sx={{ margin: '1rem' }}
                            size={{
                                xl: 9,
                                lg: 9,
                                md: 9,
                                xs: 9,
                            }}
                        >
                            <h1 className="headtxt">{t('general.searchResults')}</h1>
                        </Grid>
                        <Grid
                            className="billing-goal-resend-all"
                            size={{
                                xs: 3,
                                md: 3,
                                lg: 2,
                                xl: 2,
                            }}
                        >
                            {visibleResendButton && (
                                <SCUIButton
                                    className="billing-goal-resend-all-button"
                                    text={t('general.reSend')}
                                    type="ghost"
                                    sizeType="fixed"
                                    size={'m'}
                                    onClick={() => reSend()}
                                />
                            )}
                        </Grid>
                        <Grid
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <Box className="billing-goal-data-grid" sx={{ width: '100%' }}>
                                <SCUICustomDataGrid
                                    randomId
                                    rows={datas}
                                    columns={[
                                        {
                                            field: 'shippmentId',
                                            headerName: t('general.shippingID'),
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                return (
                                                    <a
                                                        className="billing-goal-shipping-id-link"
                                                        target="_blank"
                                                        href={
                                                            backofficeUrl +
                                                            'ShippingListDetail.aspx?ShippingListId=' +
                                                            params.row.shippmentId
                                                        }
                                                        rel="noopener noreferrer"
                                                    >
                                                        {params.row.shippmentId}
                                                    </a>
                                                );
                                            },
                                        },
                                        {
                                            field: 'failedInvoice',
                                            headerName: '',
                                            minWidth: 200,
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                return (
                                                    params.row.failed && (
                                                        <Chip
                                                            className="billing-goal-failed-invoice-chip"
                                                            label={t('billingServiceLog.failedInvoice')}
                                                            color="error"
                                                        />
                                                    )
                                                );
                                            },
                                        },
                                        {
                                            field: 'resend',
                                            headerName: '',
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                return (
                                                    !params.row.failed && (
                                                        <p
                                                            className="cursorPointer billing-goal-resend-link"
                                                            onClick={() => reSend(params.row.shippmentId)}
                                                        >
                                                            {t('general.reSend')}
                                                        </p>
                                                    )
                                                );
                                            },
                                        },
                                        {
                                            field: 'show',
                                            headerName: '',
                                            flex: 1,
                                            renderCell: (params: any) => {
                                                return (
                                                    <p
                                                        className="cursorPointer billing-goal-show-link"
                                                        onClick={() => handleShowBill(params.row)}
                                                    >
                                                        {t('general.show')}
                                                    </p>
                                                );
                                            },
                                        },
                                    ]}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                ) : (
                    <div className="billing-goal-empty-state">
                        <SCUINoRecordComponent />
                    </div>
                )}
            </Box>
        </SCUIContent>
    );
};
